module.exports = __webpack_public_path__ + "static/4-2c1b07901b1d1c91585316a11339c5cc.png";